<div *ngIf="isXpressAdminRoute">
	<app-splash></app-splash>

	<operator-login *ngIf="activeRoot===RootEnum.PartnerLogin"></operator-login>
	<operator-login *ngIf="activeRoot===RootEnum.OperatorLogin"></operator-login>
	<operator-signup *ngIf="activeRoot===RootEnum.OperatorSignUp"></operator-signup>

	<ng-container *ngIf="!operatorLogin && !operatorSignUp && !merchantLogin && !tourOperatorLogin">
		<div class="layout-wrapper" [ngClass]="{
    'layout-sidebar': menuMode === 'sidebar',
    'layout-static': menuMode === 'sidebar' && sidebarStatic,
    'layout-horizontal': menuMode === 'horizontal',
    'layout-rightpanel-active': rightPanelActive,
    'layout-slim': menuMode === 'slim',
    'layout-mobile-active': staticMenuMobileActive,
    'p-input-filled': inputStyle === 'filled', 'p-ripple-disabled': !ripple}"
			 [class]="'layout-menu-'+ menuTheme+ ' layout-topbar-'+ topbarTheme"
			 (click)="onLayoutClick()"
			 [attr.data-testid]="isMerchant() ? 'partner-root' : 'xpressadmin-shell'">

			<config></config>

			<div [ngClass]="!isMerchant() ? 'layout-main' : 'main-merchant'">
				<div [ngClass]="!isMerchant() ? 'layout-content' : 'layout-merchant'">
					<xpress-topbar (isProfileVisible)="changeProfileVisible($event)" [_showMyProfile]="isProfileVisible" style="width: 100vw; display: block; margin-bottom: 20px;"></xpress-topbar>
					<div *ngIf="isStateBased">
						<ops-tower-root *ngIf="activeRoot===RootEnum.OpsTower && !isProfileVisible "></ops-tower-root>
						<back-office-root *ngIf="activeRoot===RootEnum.BackOffice && !isProfileVisible" data-testid="back-office-root"></back-office-root>
						<marketing-root *ngIf="activeRoot===RootEnum.Marketing && !isProfileVisible" data-testid="marketing-root"></marketing-root>
						<partner-dashboard-switch *ngIf="activeRoot===RootEnum.PartnerDashboardSwitch && !isProfileVisible"></partner-dashboard-switch>
						<partner-root *ngIf="activeRoot===RootEnum.PartnerHome && !isProfileVisible"></partner-root>
						<partner-mart-locations-root *ngIf="activeRoot===RootEnum.PartnerLocations && !isProfileVisible"></partner-mart-locations-root>
						<partner-orders-root *ngIf="activeRoot===RootEnum.PartnerOrders && !isProfileVisible"></partner-orders-root>
						<partner-marketing-root *ngIf="activeRoot===RootEnum.PartnerMarketing && !isProfileVisible"></partner-marketing-root>
						<partner-insights-root *ngIf="activeRoot===RootEnum.PartnerInsights && !isProfileVisible"></partner-insights-root>
						<partner-settings-root *ngIf="activeRoot===RootEnum.PartnerSettings && !isProfileVisible"></partner-settings-root>
						<partner-finance-root *ngIf="activeRoot===RootEnum.PartnerFinanceReports && !isProfileVisible"></partner-finance-root>
					</div>
					<div [ngClass]="{'sidebar-active': sidebarActive}" *ngIf="!isStateBased">
						<router-outlet></router-outlet>
					</div>
				</div>
			</div>

			<div class="layout-mask modal-in"></div>
		</div>
		<p-toast position="top-right"></p-toast>
	</ng-container>
</div>

<!-- Show simple router outlet for non-xpressadmin routes (like region module) -->
<div *ngIf="!isXpressAdminRoute">
	<router-outlet></router-outlet>
</div>
